/* @ngInject */
export default function DiscussionLectureComponentModel(
  _,
  AbstractDiscussionLectureComponentModel,
  $translate,
  LectureComponentBaseModel,
  DiscussionsManager,
  PostModel,
  config,
) {
  class DiscussionLectureComponent extends AbstractDiscussionLectureComponentModel {
    constructor(attributes, isSample = false, useDefaults = false) {
      const defaults = {
        aiOrigin: null,
        type: 'DiscussionLectureComponent',
        editFormController: 'TopicModel',
        formName: 'discussionForm',
        post: {
          title: '',
          body: '',
          topic: null,
          starterId: null,
          expandedOnLoad: true,
        },
        isActivity: true,
        canBeCopied: true,
        addTopicToDiscussionManager: true,
      };

      super(_.extend({}, defaults, attributes), isSample, useDefaults);
    }

    getPayload() {
      const payload = {
        topic: _.pick(this.post, ['id', 'body', 'expandedOnLoad', 'isTodo', 'starterId', 'title']),
      };

      if (this.post.topic) {
        if (this.post.topic.isNewTopic) {
          payload.topic.forumTitle = this.post.topic.title;
        } else {
          payload.topic.forumId = this.post.topic.id;
        }
      } else {
        payload.topic.forumId = this.post.topicId;
      }

      // Passing the aiOrigin property through the topic object to set it into the aiProperties in the creation of the lecture component
      if (this.aiOrigin) {
        payload.topic.aiOrigin = this.aiOrigin;
      }

      return payload;
    }
  }

  return DiscussionLectureComponent;
}
